<template>
  <div>
    <div class="row" v-if="$siteAdmin == false">
      <div class="col-md-12 text-center">
        <div class="d-flex justify-content-center">
          <a href="/">
            <img
              class="img-fluid"
              :src="carregarLogo()"
              style="
                max-height: 170px;
                margin-bottom: 10px;
                max-width: 450px;
                width: 100%;
              "
              v-bind:class="{
                loginLogoStream1x2: retornaSite() == 'Stream1x2',
              }"
              v-if="retornaSite() !== '7live'"
            />
          </a>
        </div>
      </div>
    </div>
    <Dialog
      :id="retornaSite() == '7live' ? 'frmAutenticacao' : 'dialogLogin'"
      :titulo="retornaSite() == '7live' ? 'Stadiums' : 'Login'"
      ref="dialog"
      :modal="false"
      :hideHeader="retornaSite() == '7live'"
      :hideFooter="retornaSite() == '7live' ? true : false"
      :tituloCenter="retornaSite() == '7live' ? true : false"
    >
      <form class="text-left">
        <div class="form-group row">
          <label for="email" class="col-sm-12 col-form-label">Email</label>
          <div class="col-sm-12">
            <input
              class="form-control"
              v-bind:class="{ 'is-invalid': itemErros.email.status }"
              type="text"
              v-model="item.email"
              @keyup="enterEntrar"
            />
            <div v-if="itemErros.email.status" class="invalid-feedback">
              {{ itemErros.email.mensagem }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="senha" class="col-sm-12 col-form-label">{{
            retornaSite() == "Stream1x2" ? "Password" : "Senha"
          }}</label>
          <div class="col-sm-12">
            <input
              class="form-control"
              v-bind:class="{ 'is-invalid': itemErros.senha.status }"
              type="password"
              v-model="item.senha"
              @keyup="enterEntrar"
            />
            <div v-if="itemErros.senha.status" class="invalid-feedback">
              {{ itemErros.senha.mensagem }}
            </div>
          </div>
        </div>

        <div class="text-center" v-if="retornaSite() == '7live'">
          <button
            style="margin-top: 10px"
            type="button"
            class="btn btn-primary"
            @click="entrar()"
          >
            Login
          </button>

          <p style="margin-top: 10px; margin-bottom: 5px">
            <a href="/recuperar-senha">Esqueci minha senha</a>
          </p>
        </div>
      </form>

      <template v-slot:rodape v-if="retornaSite() == '7live' ? false : true">
        <button
          type="button"
          class="btn"
          v-bind:class="{
            'btn-success': retornaSite() == 'Bll',
            'btn-secondary': retornaSite() == 'Weddbets',
          }"
          @click="entrar()"
        >
          {{ retornaSite() == "Stream1x2" ? "Enter" : "Entrar" }}
        </button>
      </template>
    </Dialog>

    <div class="row" v-if="retornaSite() == 'Weddbets' && $siteAdmin == false">
      <div class="col col-md-12 d-flex justify-content-center">
        <span class="text-center">
          <a
            clsas="d-flex justify-content-center"
            href="https://t.me/Wedd_Bll"
            style="width: 100%; text-decoration: none"
            ><i
              class="fa fa-telegram"
              style="font-size: 36px; color: #0088cc"
            ></i>
            <h5 class="text-secondary" style="min-width: 135px">weddbets</h5></a
          ></span
        ><span class="text-center" style="margin-left: 10px" v-if="false">
          <a
            clsas="d-flex justify-content-center"
            href="https://wa.me/+5561986310597?text=Ol%C3%A1!%20Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20WeddBets"
            style="width: 100%; text-decoration: none"
            ><i
              class="fa fa-whatsapp"
              style="font-size: 36px; color: #34af23"
            ></i>
            <h5 style="color: black; min-width: 135px">
              <small>61 98631-0597</small>
            </h5></a
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";

export default {
  name: "Login",
  components: { Dialog },
  methods: {
    carregarLogo() {
      if (this.$sitePrincipal == "Weddbets") {
        return "/assets/logop.png";
      }

      if (this.$sitePrincipal == "Bll" && this.$darkMode == "true") {
        return "/assets/logobll2.png";
      }

      if (this.$sitePrincipal == "Bll" && this.$darkMode == "false") {
        return "/assets/logobll3.png";
      }

      if (this.$sitePrincipal == "Stream1x2") {
        return "/assets/StreamTrader.png";
      }

      if (this.$sitePrincipal == "7live") {
        return "/assets/logo_stadiums.png";
      }

      return "";
    },
    retornaSite() {
      return this.$sitePrincipal;
    },

    async entrar() {
      var objPagina = this;

      //* Limpa os erros
      this.itemErros = util.errosLimpar(this.itemErros);

      //* Carrega os dados
      var body = {
        email: this.item.email.toLowerCase(),
        senha: this.item.senha,
      };

      const apiRequest = await api.post("/sessao", body);

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);
      } else {
        if (apiRequest.data.sessao && apiRequest.data.sessao.key) {
          localStorage.setItem("ckd", apiRequest.data.sessao.key);
          localStorage.setItem(
            "ckdCch",
            JSON.stringify(apiRequest.data.sessao)
          );

          if (apiRequest.data.sessao.usuario.template) {
            localStorage.setItem(
              "template",
              apiRequest.data.sessao.usuario.template
            );
          }

          objPagina.$router.go({ name: "home" });
        }
      }
    },
    async enterEntrar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.entrar();
      }
    },
  },
  mounted() {},
  data: function () {
    return {
      item: {
        email: "",
        senha: "",
      },
      itemErros: {
        email: { status: false, mensagem: "" },
        senha: { status: false, mensagem: "" },
      },
    };
  },
};
</script>

<style>
.loginLogoStream1x2 {
  margin-top: 30px;
}
</style>
